// passwordModify.js

import request from '@/utils/request';

export function passwordModify(data) {
  return request({
    url: '/v1/user_info/password/modify',
    method: 'post',
    data: data,
  });
}

export function passwordReset(data) {
  return request({
    url: '/v1/user_info/password/reset_code',
    method: 'post',
    data: data,
  });
}

export function passwordResetPhone(data) {
  return request({
    url: '/v1/user_info/password/reset_code_phone',
    method: 'post',
    data: data,
  });
}

export function verifyEmailCode(data) {
  return request({
    url: '/v1/user_info/password/verify_email_code',
    method: 'post',
    data,
  });
}

export function verifyPhoneCode(data) {
  return request({
    url: '/v1/user_info/password/verify_phone_code',
    method: 'post',
    data,
  });
}
